<template>
  <CContainer class="d-flex align-items-center min-vh-100">
    <CRow class="w-100 justify-content-center">
      <CCol md="6">
        <div class="w-100">
          <div class="clearfix">
            <h1 class="float-left display-1 mr-4"><i class="fas fa-lock"></i></h1>
            <h4 class="pt-3">La sesión ha finalizado!.</h4>
            <h5 class="text-muted">Inicie una nueva sesión ingresando desde la página web de la Institución Educativa o ingrese la dirección (URL) que le suministraron.</h5>
          </div>
        </div>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
  export default {
    name: 'SesionFinalizada'
  }
</script>
